import { render, staticRenderFns, recyclableRender, components } from "./getItem.vue?vue&type=template&id=d5170d74&scoped=true&"
var renderjs
import script from "./getItem.vue?vue&type=script&lang=js&"
export * from "./getItem.vue?vue&type=script&lang=js&"
import style0 from "./getItem.vue?vue&type=style&index=0&id=d5170d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5170d74",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/merchant/merchatCenter/coupon/getItem.vue"
export default component.exports